





















import Vue from 'vue';
import CopyPaste from './components/CopyPaste.vue';

export default Vue.extend({
  name: 'app',
  components: {
    CopyPaste
  },
  data() {
    return {
      showMore: false
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue